import React from "react";
import { chain, configureChains, createClient, WagmiConfig } from "wagmi";
import { infuraProvider } from "wagmi/providers/infura";
import { MetaMaskConnector } from "wagmi/connectors/metaMask";
import { WalletConnectConnector } from "wagmi/connectors/walletConnect";
import { Buffer } from "buffer";
import MintPage from "./components/pages/MintPage";

const { chains, provider, webSocketProvider } = configureChains(
  [process.env.REACT_APP_CHAIN_ID === "5" ? chain.goerli : chain.mainnet],
  [infuraProvider({ apiKey: process.env.REACT_APP_INFURA_API! })]
);

const client = createClient({
  autoConnect: true,
  connectors: [
    new MetaMaskConnector({ chains }),
    new WalletConnectConnector({
      chains,
      options: {
        qrcode: true,
      },
    }),
  ],
  provider,
  webSocketProvider,
});

function App() {
  // @ts-ignore
  window.Buffer = Buffer;
  return (
    <WagmiConfig client={client}>
      <MintPage />
    </WagmiConfig>
  );
}

export default App;
